<template>
  <section fluid>
    <section class="section-box section-box-list" style="padding: 30px;">
      <div class="text-xs-center">
        <v-btn round depressed large color="success" dark
          v-modal-trigger="'showNewTrainingDialog'">
          Cadastrar novo
          <v-icon small right>fal fa-plus-circle</v-icon>
        </v-btn>
        <v-btn round depressed large color="deep-orange darken-2" dark v-if="trainings.length"
          v-modal-trigger="'showNewNotification'" :data-item="JSON.stringify(newNotificationData)">
          Notificar aluno
          <v-icon small right>fal fa-bell</v-icon>
        </v-btn>
      </div>
    </section>
    <br>
    <v-expansion-panel>
      <div class="section-box section-box-list" v-for="(training, index) in trainings" :key="index">
        <v-expansion-panel-content expand-icon="fal fa-angle-down">
          <div slot="header">
            {{ training.name }}
          </div>
          <section class="mx-4">
            <training-item :training="training"></training-item>
            <div class="text-xs-center">
              <v-btn flat small color="red lighten-2" @click="deleteItem(training)">
                <v-icon small left>fal fa-trash-alt</v-icon> Excluir treino
              </v-btn>
            </div>
          </section>
        </v-expansion-panel-content>
      </div>
    </v-expansion-panel>
    <new-training-dialog :user="user._id"></new-training-dialog>
    <user-show-exercise></user-show-exercise>
  </section>
</template>

<script>
import axios from 'axios'
import EventBus from '@/event-bus'

import UserShowExercise from '@/components/user/exercises/UserShowExercise.vue'
import AdminNewTrainingDialog from '@/components/admin/trainings/AdminNewTrainingDialog'
import AdminUserShowTrainingItem from '@/components/admin/userShow/AdminUserShowTrainingItem'

export default {
  data: () => ({
    trainings: []
  }),

  components: {
    'new-training-dialog': AdminNewTrainingDialog,
    'training-item': AdminUserShowTrainingItem,
    UserShowExercise
  },

  methods: {
    loadTrainings () {
      // eslint-disable-next-line
      axios.get(`${API.userTrainings}/?user=${this.$route.params.id}`).then(response => {
        this.trainings = response.data.trainings
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar os treinos', color: 'error' })
      })
    },

    deleteItem (item, confirmUnRequired) {
      // eslint-disable-next-line
      const path = `${API.userTrainings}/${item._id}`
      const index = this.trainings.indexOf(item)

      if (!confirmUnRequired) {
        confirm(`Tem certeza que deseja apagar o treino "${item.name}" ?`) && this.deleteItem(item, true)
        return
      }

      axios.delete(path).then(response => {
        this.trainings.splice(index, 1)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro apagar o item', color: 'error' })
        EventBus.$emit('loadTrainings')
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadTrainings')
  },

  created () {
    this.loadTrainings()
    EventBus.$on('loadTrainings', this.loadTrainings)
  },

  computed: {
    newNotificationData () {
      return {
        user: this.user._id,
        all_users: false,
        title: 'Você tem um novo treino!',
        message: `${this.user.first_name}, confira seu novo treino`,
        // eslint-disable-next-line
        url: `${API.siteURL}/trainings`
      }
    }
  },

  props: ['user']
}
</script>



// WEBPACK FOOTER //
// src/components/admin/userShow/AdminUserShowTraining.vue